import { Hooks } from '@wordpress/hooks';
import WooCommerceAccounting from './woocommerce-accounting.d';
import { DokanManualOrder } from '../features/manual-order/definitions';

interface AllowedCountries {
    [ code: string ]: string;
}

interface Continent {
    [ code: string ]: {
        // Define the structure of each continent if needed
    };
}

interface State {
    [ countryCode: string ]:
        | {
        [ stateCode: string ]: string;
    }
        | [];
}

interface ShippingClass {
    term_id: number;
    name: string;
    slug: string;
    term_group: number;
    term_taxonomy_id: number;
    taxonomy: string;
    description: string;
    parent: number;
    count: number;
    filter: string;
}

interface ProcessingTime {
    [ key: string ]: string;
}

interface dokanShippingHelperDefinitions {
    nonce: string;
    allowed_countries: AllowedCountries;
    continents: Continent;
    states: State;
    shipping_class: ShippingClass[];
    processing_time: ProcessingTime;
    dashboardUrl: string;
}

interface ProductCategory {
    value: string;
    label: string;
    parent: number;
    count: number;
    slug: string;
    children?: ProductCategory[];
}

interface DokanGeoProductCategories {
    categories: ProductCategory[];
    selected: string[];
}

/**
 * To get dokan supports just import like a normal js file
 * Ex: import '../path.../src/Definitions/window-types';
 */
declare global {
    interface Window extends Window {
        wp: {
            hooks: Hooks;
        };
        dokanProductSubscription: {
            currencySymbols: Record< string, string >;
        };
        dokan_get_daterange_picker_format: () => string;
        moment: ( date: string ) => any;
        DokanRMA: {
            [ key: string ]: any;
        };
        DokanRMAPanel: {
            [ key: string ]: any;
        };
        accounting: WooCommerceAccounting.AccountingStatic;
        dokanManualOrder?: DokanManualOrder;
        dokanShippingHelper?: dokanShippingHelperDefinitions;
        dokanGeoProductCategories?: DokanGeoProductCategories;
    }
}

// This empty export is necessary to make this a module
export {};
